<template>
  <div>
    <report-panel :anchor="anchor">
      <div slot="title">Company Details</div>
      <div slot="body">
        <table class="table table-striped" id="company-details-table">
          <tbody>
            <tr>
              <th scope="row">Company Name:</th>
              <td>
                {{report.companyoverview.company_name}}
              </td>
            </tr>
            <tr>
              <th scope="row">Company Registration Number:</th>
              <td>
                {{report.companyoverview.company.registration_number}}
              </td>
            </tr>
            <tr>
              <th scope="row">Company Type:</th>
              <td>
                {{ companyTypeName }}
              </td>
            </tr>
            <tr>
              <th scope="row">Company Status:</th>
              <td v-if="showDiff && hasStatusDiff">
                <table width="100%">
                  <tr style="border-bottom: 1px solid #aaaaaa;">
                    <th class="diff diff-old text-left">
                      {{ statusDiff.date }}
                    </th>
                    <th class="diff diff-new text-left">
                      {{ formatDate(report.companyoverview.created_at) }}
                    </th>
                  </tr>
                  <tr style="height: 30px;">
                    <td class="diff diff-old text-left">
                      <span v-bind:class="setLabeltoStatus(statusDiff.status)">
                        {{ statusDiff.status }}
                      </span>
                    </td>
                    <td class="diff diff-new text-left">
                      <span v-bind:class="setLabeltoStatus(report.companyoverview.officialstatus.name)">
                        {{ report.companyoverview.officialstatus.name }}
                      </span>
                    </td>
                  </tr>
                </table>
              </td>
              <td v-else>
				<company-status :company-overview="report.companyoverview" />
              </td>
            </tr>
            <tr>
              <th scope="row">Date Incorporated:</th>
              <td>
                {{formatDate(report.companyoverview.incorporated_date)}} &nbsp;({{formatAge(report.companyoverview.company_age_in_years,'years')}})
              </td>
            </tr>
            <tr>
              <th scope="row">Number Of Active Directors:</th>
              <td>
                {{ numberOfActiveDirectors }}
                <span v-if="numberOfActiveDirectors == 1">&nbsp;active director.</span>
                <span v-else>&nbsp;active directors.</span>
              </td>
            </tr>
            <tr v-if="report && report.includes_sanctions">
              <th scope="row">Number Of Potential Sanction Matches:</th>
              <td>
                <div v-if="sanctionsCount === 1">
                  <span class="fas fa-exclamation-triangle hse-warning"></span>&nbsp;{{ sanctionsCount }}&nbsp;sanction match found.
                </div>
                <div v-else>
                  <span v-if="sanctionsCount > 0" class="fas fa-exclamation-triangle hse-warning"></span>{{ sanctionsCount }}&nbsp;sanction matches found.
                </div>
              </td>
            </tr>
            <tr v-else>
              <th scope="row">Number Of Potential Sanction Matches:</th>
              <td>
                Report was generated before sanction data was available.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </report-panel>
  </div>
</template>

<script>
import toolsMixin from '@/components/reports/ToolsMixin.js';
import ReportPanel from '@/components/reports/components/ReportPanel';
import CompanyStatus from '../components/CompanyStatus';

export default {
  components: {
  	CompanyStatus,
    ReportPanel,
  },
  computed: {
    anchor() {
      if (this.showAnchor) {
        return '#about';
      }
      return '';
    },
    companyTypeName() {
      if (
        this.report !== undefined
          && this.report.companyOverview !== undefined
          && this.report.companyOverview.companytype !== undefined
      ) {
        return this.report.companyOverview.companytype.name;
      }
      return 'N/A';
    },
    hasStatusDiff() {
      const result = this.diffData.find((d) => d.type == 'status');
      return result !== undefined;
    },
    hseCasesCount() {
      const cases = [];
      for (let i = 0; i < this.report.companyoverview.hsecases.length; i++) {
        if (this.report.companyoverview.hsecases[i].length != 0) {
          cases.push(this.report.companyoverview.hsecases[i]);
        }
      }
      return cases.length;
    },
    numberOfActiveDirectors() {
      let directorsCount = 0;
      for (let i = 0; i < this.report.companyoverview.officers.length; i++) {
        if (this.report.companyoverview.officers[i].current_status === 'open') {
          directorsCount += 1;
        }
      }
      return directorsCount;
    },
    numberOfInactiveDirectors() {
      let directorsCount = 0;
      for (let i = 0; i < this.report.companyoverview.officers.length; i++) {
        if (
          this.report.companyoverview.officers[i].current_status === 'closed'
        ) {
          directorsCount += 1;
        }
      }
      return directorsCount;
    },
    sanctionsCount() {
      const sanctions = [];
      for (let i = 0; i < this.report.companyoverview.sanctions.length; i++) {
        if (this.report.companyoverview.sanctions[i].length != 0) {
          sanctions.push(this.report.companyoverview.sanctions[i]);
        }
      }
      return sanctions.length;
    },
    simpleStatusName() {
      if (
        this.report.companyOverview
          && this.report.companyOverview.simplestatus
      ) {
        return this.report.companyOverview.simplestatus.name;
      }
      return 'N/A';
    },
    statusDiff() {
      return this.diffData.find((d) => d.type === 'status');
    },
  },
  mixins: [toolsMixin],
  props: ['diffData', 'report', 'showAnchor', 'showDiff'],
};
</script>
